/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EnrollmentJobStageOption } from './enrollmentJobStageOption';
import type { EnrollmentListItem } from './enrollmentListItem';
import type { EnrollmentListStats } from './enrollmentListStats';
import type { EnrollmentStepOption } from './enrollmentStepOption';

export interface EnrollmentListResponse {
  enrollments: EnrollmentListItem[];
  /** @minimum 0 */
  total: number;
  stats?: EnrollmentListStats;
  /** @minimum 0 */
  step_count?: number;
  steps?: EnrollmentStepOption[];
  job_stages?: EnrollmentJobStageOption[];
}
